/** Convert an API value into the text contract expected by form controls. */
export function toFormFieldText(value) {
  return value === null || value === undefined ? '' : String(value);
}
